import { Component } from '@angular/core';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';

@Component({
	selector: 'app-insurance-generate',
	templateUrl: './insurance-generate.component.html',
	styleUrls: ['./insurance-generate.component.css'],
})
export class InsuranceGenerateComponent {
	forDate = '';
	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly erp: Data2Service,
		private readonly loader: LoaderService,
	) {}

	submit(): void {
		const data = {
			cmd: 'cure',
			date: this.forDate,
		};
		this.api.command('/istour/IstourInsurance/', data, (result, error) => {
			if (error) {
				return;
			}
			this.infobox.success('Zapisano pomyślnie. Generowanie rozpocznie się za chwilę');
		});
	}
}
